import React, { useContext } from 'react';
import Isvg from 'react-inlinesvg';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Message from 'components/Message';
import { ICONS, PFE_ICONS } from 'constants/icons';
import LINKS from 'constants/links';
import { bem } from 'helpers/class-name';

import CookiesContext from '../CookiesContext';

import { messages } from './YourPrivacyChoicesModal.messages';

import './YourPrivacyChoicesModal.scss';

const { block, element } = bem('your-privacy-choices-modal');

function YourPrivacyChoicesModal({ contactUsUrl }) {
  const {
    showYourPrivacyChoicesModal,
    closeYourPrivacyChoicesModal,
    openModal: openCookieModal,
  } = useContext(CookiesContext);

  return (
    <ReactModal
      isOpen={showYourPrivacyChoicesModal}
      shouldFocusAfterRender={false}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      ariaHideApp={process.env.NODE_ENV !== 'test'}
      overlayClassName={element('overlay')}
      className={block()}
      onRequestClose={closeYourPrivacyChoicesModal}>
      <h3 className={element('header')}>
        <Message message={messages.header} />
        <Isvg src={ICONS.cross} className={element('close-icon')} onClick={closeYourPrivacyChoicesModal} />
      </h3>

      <p className={element('description')}>
        <Message message={messages.description} />
      </p>

      <section className={element('section')}>
        <h4 className={element('subtitle')}>
          <Message message={messages.saleSharingAndTargetedAdvertisingSubtitle} />
        </h4>
        <p className={element('body-text', { noMargin: true })}>
          <Message message={messages.saleSharingAndTargetedAdvertisingBodyText1} />
        </p>
        <ul className={element('list')}>
          <li className={element('body-text')}>
            <Message message={messages.saleSharingAndTargetedAdvertisingListItem1} />
          </li>
          <li className={element('body-text')}>
            <Message message={messages.saleSharingAndTargetedAdvertisingListItem2} />
          </li>
        </ul>
        <p className={element('body-text')}>
          <Message message={messages.saleSharingAndTargetedAdvertisingBodyText2} />
        </p>
        <p className={element('body-text')}>
          <Message message={messages.saleSharingAndTargetedAdvertisingBodyText3} />
        </p>
      </section>

      <section className={element('section')}>
        <h4 className={element('subtitle')}>
          <Message message={messages.optOutSubtitle} />
        </h4>
        <p className={element('body-text')}>
          <Message message={messages.optOutBodyText1} />
        </p>
        <Button styled="primary-outline" className={element('cookie-preferences')} onClick={openCookieModal}>
          <Message message={messages.cookiePreferences} />
        </Button>
        <p className={element('body-text')}>
          <Message message={messages.optOutBodyText2} />
        </p>
        <p className={element('body-text')}>
          <Message message={messages.optOutBodyText3} />
        </p>
        <p className={element('body-text')}>
          <Message
            message={messages.optOutBodyText4}
            values={{
              'contact-us-link': chunks => (
                <a href={contactUsUrl} target="_blank" rel="noreferrer noopener" className={element('link')}>
                  {chunks}
                </a>
              ),
            }}
          />
        </p>
      </section>

      <section className={element('section')}>
        <h4 className={element('subtitle')}>
          <Message message={messages.sensitivePersonalInformationSubtitle} />
        </h4>
        <p className={element('body-text')}>
          <Message message={messages.sensitivePersonalInformationBodyText} />
        </p>
      </section>

      <section className={element('section')}>
        <h4 className={element('subtitle')}>
          <Message message={messages.moreInformationSubtitle} />
        </h4>
        <p className={element('body-text')}>
          <Message
            message={messages.moreInformationBodyText}
            values={{
              'privacy-policy-link': chunks => (
                <a
                  href={LINKS.privacyPolicy.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  className={element('link')}>
                  {chunks}
                </a>
              ),
            }}
          />
        </p>
      </section>

      <div className={element('footer')}>
        <div className={element('footer-bar')} />
        <Isvg src={PFE_ICONS.logotype} className={element('logo')} />
        <Button
          styled="link"
          tagName="a"
          href={LINKS.privacyPolicy.href}
          target="_blank"
          rel="noreferrer noopener"
          className={element('action', { link: true })}>
          <Message message={messages.privacyPolicy} />
        </Button>
      </div>
    </ReactModal>
  );
}

YourPrivacyChoicesModal.propTypes = {
  contactUsUrl: PropTypes.string,
};

export default YourPrivacyChoicesModal;
